import { ClockCounterClockwise } from "@phosphor-icons/react";
import { useState } from "react";

import { NotEnoughSeatsDialog } from "features/subscriptions/components";

import { SplitButton } from "common/components/SplitButton";

import { useCampaignContext } from "../../../../../context/CampaignContext";
import useCampaignValidation from "../../../../../hooks/useCampaignValidation";
import CampaignStart from "./CampaignStart";

export default function StartCampaignButton() {
  const [isLicensesModalOpen, setIsLicensesModalOpen] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isScheduled, setIsScheduled] = useState<boolean>();

  const { owners } = useCampaignContext();

  const { workerAccountsWithoutSeat, hasInsufficientLicenses } =
    useCampaignValidation(owners);

  function onStartCampaign(shouldSchedule: boolean) {
    if (hasInsufficientLicenses) {
      setIsLicensesModalOpen(true);
      return;
    }

    setIsScheduled(shouldSchedule);
    setIsDialogOpen(true);
  }

  return (
    <>
      <SplitButton
        onClick={() => onStartCampaign(false)}
        dropdownMenuItems={[
          {
            label: "Schedule campaign",
            icon: ClockCounterClockwise,
            onSelect: () => onStartCampaign(true),
          },
        ]}
      >
        Start
      </SplitButton>
      <NotEnoughSeatsDialog
        isOpen={isLicensesModalOpen}
        setIsOpen={setIsLicensesModalOpen}
        noSeatAccountIds={workerAccountsWithoutSeat.map(({ id }) => id)}
        mixpanelSource="upsell_campaign"
      />

      <CampaignStart
        isOpen={isDialogOpen}
        isScheduled={isScheduled}
        onClose={() => setIsDialogOpen(false)}
      />
    </>
  );
}
